import { Component, Ref } from "@eastsideco/salvo-ts";
import { ThemeComponent } from "@/theme/ThemeComponent";

@Component
export class MobilePanel extends ThemeComponent {
    @Ref() closeButton!: HTMLButtonElement;

    init() {
        this.$listen(this.closeButton, 'click', () => {
            this.classList.remove('mobile-panel--active');
            document.body.classList.remove('mobile-panel-open');
        });
    }
}
